export const OFFSET_FOR_STICKY = 50;
